var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"axis-rectify-page"},[_c('iframe',{ref:"frame",staticClass:"axis-rectify-frame",attrs:{"src":"/axis-rectify.html","frameborder":"0","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }